import React, { useState, useEffect, useRef } from "react";
import TextInput from "../../../../../common/TextInput";
import {
  PaymentProcessContainer,
  PaymentProcessHead,
  PaymentProcessHeading,
  PaymentProcessDescription,
  PaymentProcessBottom,
  PaymentProcessLeft,
  PaymentProcessLabel,
  PaymentMethods,
  CreditCard,
  Paypal,
  TextInputs,
  ActionButtons,
  Button,
  Text,
  PaymentProcessRight,
  PaymentProcessRightHeading,
  PaymentOption,
  RoundCircle,
  PlanDescription,
  PlanHeading,
  Amount,
  Total,
  TotalLabel,
  TotalAmount,
  Guarantee,
  GuaranteeText,
} from "./styles";
import CheckoutForm from "./CheckoutForm";
import { Context } from "../../../../../Store";
import { getUserInfo } from "../../../../../Store/User/accessors";
import callAPI from "../../../../../api/apiCaller";

const PaymentProcess = ({ plan, program }) => {
  const { state, dispatch } = React.useContext(Context);

  const userData = getUserInfo(state);

  const paypal = useRef(null);

  const [selected, setSelected] = useState("stripe");
  const [clientSecret, setClientSecret] = useState("");
  // const [paypalPlanId, setPaypalPlanId] = useState("");

  const selectionChangeHandler = (value) => {
    setSelected(value);
  };

  const createSubscriptionWithStripeHandler = () => {
    callAPI(dispatch, "createSubscriptionWithStripe", {
      userId: userData?.id,
      priceId: "price_1RegWV08Lrh8yUaatVlUIjzf",
      userEmail: userData?.email,
      plan,
      programId: program?.id ? program?.id : "",
    })
      .then((res) => {
        setClientSecret(res?.data?.clientSecret);
      })
      .catch((error) => {
        setClientSecret("");
      });
  };

  useEffect(() => {
    if (userData?.id && selected === "stripe") {
      createSubscriptionWithStripeHandler();
      // setPaypalPlanId("");
    } else if (userData?.id && selected === "paypal") {
      // createSubscriptionWithPayPalHandler();
      setClientSecret("");
    }
  }, [userData, selected]);

  // useEffect(() => {
  //   if (paypalPlanId && selected === "paypal") {
  //     window.paypal
  //       .Buttons({
  //         createSubscription: function (data, actions) {
  //           return actions.subscription.create({
  //             plan_id: paypalPlanId, // Creates the subscription
  //           });
  //         },
  //         onApprove: function (data, actions) {
  //           alert("You have successfully subscribed to " + data.subscriptionID); // Optional message given to subscriber
  //         },
  //         onError: (err) => {
  //           console.log(err);
  //         },
  //       })
  //       .render(paypal.current);
  //   }
  // }, [paypalPlanId, selected]);

  useEffect(() => {
    if (selected === "paypal") {
      window.paypal
        .Buttons({
          createSubscription: function (data, actions) {
            return fetch(
              `http://localhost:3000/api/v1/paypal/create-paypal-subscription-plan/${userData?.id}/${userData?.email}/${plan}`,
              {
                method: "POST",
              }
            )
              .then((res) => res.json())
              .then((result) => {
                console.log("Result:", result);

                return result?.data?.subscriptionId; // Must be a string
              })
              .catch((err) => {
                console.error("Failed to create subscription via backend", err);
              });
          },
          onApprove: function (data, actions) {
            // alert("You have successfully subscribed to " + data.subscriptionID);
            window.location.reload();
          },
          onError: (err) => {
            console.log(err);
          },
        })
        .render(paypal.current);
    }
  }, [selected, plan, userData]);

  return (
    <PaymentProcessContainer>
      <PaymentProcessHead>
        <PaymentProcessHeading>
          {`Upgrade to ${plan} Plan`}
        </PaymentProcessHeading>
        <PaymentProcessDescription>
         Do more with larger mentorship groups
        </PaymentProcessDescription>
      </PaymentProcessHead>

      <PaymentProcessBottom>
        <PaymentProcessLeft>
          <PaymentProcessLabel>Pay with</PaymentProcessLabel>
          <PaymentMethods>
            <CreditCard
              style={{
                backgroundColor:
                  selected === "stripe" ? "white" : "rgb(247, 247, 249)",
              }}
              onClick={() => selectionChangeHandler("stripe")}
            >
              Credit Card
            </CreditCard>

            <Paypal
              style={{
                backgroundColor:
                  selected === "paypal" ? "white" : "rgb(247, 247, 249)",
              }}
              onClick={() => selectionChangeHandler("paypal")}
            >
              Paypal
            </Paypal>
          </PaymentMethods>

          {selected === "stripe" && !clientSecret
            ? "Loading..."
            : clientSecret &&
              selected === "stripe" && (
                <CheckoutForm clientSecret={clientSecret} />
              )}

          {/* selected === "paypal" && !paypalPlanId
            ? "Loading..."
            : paypalPlanId && selected === "paypal" && <div ref={paypal}></div> */}

          {selected === "paypal" && selected === "paypal" && (
            <div ref={paypal}></div>
          )}
        </PaymentProcessLeft>

        <PaymentProcessRight>
          <PaymentProcessRightHeading>Pro Plan</PaymentProcessRightHeading>
          <PaymentOption>
            <PlanDescription>
              <PlanHeading>Pay Monthly</PlanHeading>
              <Amount>$2 / Month / Member</Amount>
            </PlanDescription>
          </PaymentOption>
          <Total>
            <TotalLabel>Total</TotalLabel>
            <TotalAmount>$500 / month</TotalAmount>
          </Total>
          <Guarantee>
            <GuaranteeText>
              Guaranteed to be safe and secure, ensuring that all transaction
              are protected with the highest level of security.
            </GuaranteeText>
          </Guarantee>
        </PaymentProcessRight>
      </PaymentProcessBottom>
    </PaymentProcessContainer>
  );
};

export default PaymentProcess;
